import api from "@cx/http"; // eslint-disable-line no-restricted-imports
import { getApiConfig } from "../util/apiConfigHelper";

export function registerNewUser(request, reCaptchaToken) {
  const { post } = api(getApiConfig(reCaptchaToken));
  return post("api/registration/register", request);
}
